export enum BulkActionsRequestTypes {
  BulkArchiveObjectsRequest = 'BulkActionsProto.ArchiveObjects.Request',
  BulkArchiveObjectsSuccess = 'BulkActionsProto.ArchiveObjects.Success',
  BulkArchiveObjectsFailure = 'BulkActionsProto.ArchiveObjects.Failure',
}
